<template>
  <section v-if="!isMobile" style="padding: 20px;">
    <!-- <div class="new_page_tabpc" style="padding-left: 13%;">
      <router-link to="/sport/lsport/prematch" ><span>엘스포츠 유럽형</span></router-link>
      <router-link to="/sport/prematch" ><span>벳컨 유럽형</span></router-link>
      <router-link :to="{ name: '오즈매트릭스-아이프레임' }" class="cho" ><span>오즈메트릭스 유럽형</span></router-link>
    </div> -->
    <div class="gameBox" v-if="url" style="width: 98%; height: 100vh;">
      <iframe scrolling="no" frameborder="0"
              style="width: 100%; height: 100%;"
              allowFullScreen="true"
              :src="url">
      </iframe>
    </div>
  </section>
  <div v-else style="width: 100%;">
    <!-- <div class="new_page_tab">
      <router-link to="/sport/lsport/prematch" ><span>엘스포츠 유럽형</span></router-link>
      <router-link to="/sport/prematch"><span>벳컨 유럽형</span></router-link>
      <router-link :to="{ name: '오즈매트릭스-아이프레임' }" class="cho"><span>오즈메트릭스 유럽형</span></router-link>
    </div> -->
    <div v-if="url" class="mobile-iframe-wrap">
      <iframe frameborder="0"
              class="mobile-iframe"
              allowFullScreen="true"
              :src="url">
      </iframe>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "SportIntegrationInplay",
  components: {
  },
  data: function(){
    return {
      url: null,
      siteName: 'luna',
      pointColor: '#a97bf5',
    }
  },
  mounted() {
    this.initUrl();
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
      isMobile: state => state.page.isMobile,
    }),
  },
  watch: {
    user: function(val){
      if (val) {
        this.initUrl();
      }
    }
  },
  methods: {
    initUrl: function(){
      let token = localStorage.getItem("authToken");
      this.url = null;
      const siteName = this.siteName;
      const pointColor = this.pointColor;
      const baseUrl = `https://inplay.j6rgtq98rh95vq5wbqsrdacx3.xyz/betconstruct/inplay/${this.isMobile ? 'mobile' : 'desktop'}`;
      const params = [];
      if (token) {
        params.push(`token=${token}`);
      }
      if (siteName) {
        params.push(`siteName=${siteName}`);
      }
      if (pointColor) {
        params.push(`pointColor=${encodeURIComponent(pointColor)}`);
      }

      if (params.length > 0) {
        this.url = `${baseUrl}?${params.join('&')}`;
      } else {
        this.url = baseUrl;
      }
    }
  }
}
</script>

<style scoped>
.mobile-iframe-wrap {
  width: 100%;
  height: calc(100vh - 50px);
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  padding: 3px;
  box-sizing: border-box;
}

.mobile-iframe {
  width: 100%;
  min-height: 100%;
  margin: 0;
  padding: 0;
  border: none;
  display: block;
}
</style>
